class CalculatorPopup extends HTMLElement {
  constructor() {
    super();

    this.closeButtons = document.querySelectorAll('.calculator-popup__close');
    this.openButton = document.querySelector('.calculator-popup__trigger');
    this.popupContainer = this.querySelector('.calculator-popup__container');
    this.addCartButton = this.querySelector('.calculator__add-to-cart');
    this.handleKeydown = this.handleKeydown.bind(this);
    this.lastFocusedElement = null;
  }

  connectedCallback() {
    this.addEventListener('click', (e) => {
      if(!this.popupContainer?.contains(e.target)) {
        this.close();
      }
    });

    this.closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', this.close.bind(this));
    });

    this.addCartButton?.addEventListener('click', this.close.bind(this));

    this.openButton?.addEventListener('click', this.open.bind(this));
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  open() {
    this.lastFocusedElement = document.activeElement;
    this.classList.add('calculator-popup--active');
    document.documentElement.classList.add('js-drawer-open');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const firstFocusableElement = this.getFocusableElements()[0];
      firstFocusableElement?.focus();
    }));
  }

  close() {
    this.classList.remove('calculator-popup--active');
    document.documentElement.classList.remove('js-drawer-open');
    this.lastFocusedElement?.focus?.();
  }

  getFocusableElements() {
    if (!this.popupContainer) {
      return [];
    }

    return Array.from(this.popupContainer.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(element => element.offsetParent !== null);
  }

  handleKeydown(event) {
    if (!this.classList.contains('calculator-popup--active')) {
      return;
    }

    if (event.key === 'Escape' || event.code === 'Escape') {
      this.close();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusableElements = this.getFocusableElements();
    if (!focusableElements.length) {
      return;
    }

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (!this.popupContainer.contains(document.activeElement)) {
      event.preventDefault();
      firstFocusableElement.focus();
      return;
    }

    if (event.shiftKey && document.activeElement === firstFocusableElement) {
      event.preventDefault();
      lastFocusableElement.focus();
      return;
    }

    if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  }
}

customElements.define('calculator-popup', CalculatorPopup);
